module.exports = __webpack_public_path__ + "img/mpovt.b012fc48.png";